import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { IS_STAGING, PATH } from '@constants';

import { PlatformAppsLayout } from '@components/Layouts';

import { withSuspense } from './utils';

const PlatformAppsTemplatesPage = lazy(
  () => import('@pages/PlatformApps/PlatformAppsTemplatesPage'),
);
const PlatformAppsInstalledPage = lazy(
  () => import('@pages/PlatformApps/PlatformAppsInstalledPage'),
);
const PlatformAppsExplorationPage = lazy(
  () => import('@pages/PlatformApps/PlatformAppsExplorationPage'),
);
const PlatformAppsInstallingPage = lazy(
  () => import('@pages/PlatformApps/PlatformAppsInstallingPage'),
);
const LegacyAppsPage = lazy(() => import('@pages/PlatformApps/LegacyAppsPage'));
const PlatformAppsDevSchemaPage = lazy(
  () => import('@pages/PlatformApps/PlatformAppsDevSchemaPage'),
);

export default function PlatformAppsRoutes() {
  return (
    <Routes>
      <Route element={<PlatformAppsLayout />}>
        <Route index element={withSuspense(PlatformAppsTemplatesPage)} />

        <Route
          path="installed/:appName"
          element={withSuspense(PlatformAppsInstalledPage)}
        />

        <Route
          path="installed"
          element={withSuspense(PlatformAppsInstalledPage)}
        />
        <Route path="legacy" element={withSuspense(LegacyAppsPage)} />

        {!IS_STAGING && (
          <Route
            path="dev-schema"
            element={withSuspense(PlatformAppsDevSchemaPage)}
          />
        )}
      </Route>

      <Route
        path=":appName/:version"
        element={withSuspense(PlatformAppsExplorationPage)}
      />

      <Route
        path=":appName"
        element={withSuspense(PlatformAppsExplorationPage)}
      />

      <Route
        path=":appName/install"
        element={withSuspense(PlatformAppsInstallingPage)}
      />

      <Route
        path=":appName/install/:version"
        element={withSuspense(PlatformAppsInstallingPage)}
      />

      <Route path="*" element={<Navigate replace to={PATH.APPS} />} />
    </Routes>
  );
}
